<template>
  <component
    :is="tag"
    ref="root"
    class="[&_h2]:text-2xl md:[&_h2]:text-4xl [&_h3]:text-xl [&_h4]:text-xl md:[&_h3]:text-2xl [&_h2,&_h3,&_h4]:mb-5 [&_*+h2,&_*+h3,&_*+h4]:mt-7.5 [&_h2,&_h3,&_h4]:font-semibold [&_a]:underline [&_a]:text-(--main-color) [&_ul,&_ol]:flex [&_ul,&_ol]:flex-col [&_ul,&_ol]:gap-2 [&_ul>li,&_ol>li]:pl-5.5 [&_ul>li,&_ol>li]:relative [&_ul>li]:before:content-[''] counter-reset [&_ul>li]:before:block [&_ul>li]:before:rounded-full [&_ul>li]:before:w-2 [&_ul>li,&_ol>li]:before:absolute [&_ul>li,&_ol>li]:before:top-[0.5rem] [&_ul>li,&_ol>li]:before:left-0 [&_ol>li]:before:-translate-y-[0.5rem] [&_ul>li]:before:h-2 [&_ul>li]:before:bg-(--main-color) [&_ol>li]:before:text-(--main-color) [&_ol>li]:before:font-semibold"
  />
</template>

<script setup lang="ts">
import DOMPurify from 'dompurify'
import { nextTick, ref, watch } from 'vue'

defineOptions({ name: 'RawHtml' })

const props = withDefaults(
  defineProps<{
    html: string
    tag?: string
  }>(),
  { tag: 'div' },
)

const root = ref<HTMLElement>()

const renderHTML = async () => {
  await nextTick()

  if (!root.value) return

  root.value.innerHTML = ''

  if (!props.html) return

  root.value.insertAdjacentHTML('beforeend', DOMPurify.sanitize(props.html))

  root.value.querySelectorAll('a[href^="http"]').forEach((externalLink: HTMLAnchorElement) => {
    externalLink.target = '_blank'
    externalLink.rel = 'noopener'
  })
}

watch(() => props.html, renderHTML, { immediate: true })
</script>
